export default __webpack_public_path__ + "static/media/statusPending.d5e1cf74.png";